import type { ClientOptions, Host } from '@algolia/client-common';
import type { LiteClient } from 'algoliasearch/lite';

import { liteClient } from 'algoliasearch/lite';
import { useMemo } from 'react';

import { Environments } from '../../constants';
import { useStaticContext } from '../../context/static/StaticContext';
import logger from '../../logger';
import { useAppContext } from '~/utilities/context/static/AppContext';

export const useAlgoliaClient = (): LiteClient | undefined => {
  const { algoliaCustomHost } = useAppContext();
  const {
    // "algoliaInsightsApiKey" is algolia search api key
    configuration: { algoliaAppId, algoliaInsightsApiKey },
  } = useStaticContext();

  const algoliaClient = useMemo(() => {
    const isProduction = process.env.ENVIRONMENT === Environments.PRD;

    const hosts: Array<Host> = algoliaCustomHost.map(customHost => ({
      url: customHost,
      accept: 'read',
      protocol: 'https',
    }));

    if (algoliaAppId && algoliaInsightsApiKey) {
      const algoliaOptions: ClientOptions = {
        ...(isProduction ? { hosts } : {}),
      };

      return liteClient(algoliaAppId, algoliaInsightsApiKey, algoliaOptions);
    }

    logger.error(
      `Missing "algoliaAppId" and/or "algoliaInsightsApiKey", can't start algolia client!`
    );

    return undefined;
  }, [algoliaAppId, algoliaInsightsApiKey, algoliaCustomHost]);

  return algoliaClient;
};
